'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "icon-ring"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 216 216"
      }
    }, [_c('circle', {
      attrs: {
        "r": "100",
        "cy": "50%",
        "cx": "50%"
      }
    })])]);
  },
  staticRenderFns: [],
  name: 'icon-ring'
});

exports.default = index;
